import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`React`}</h2>
    <p>{`Du JavaScript sous stéroïdes qui vous permet d'avoir un front-end plus musclé que Mister Univers. Ce petit coquin peut même s’infiltrer dans votre back-end.
Netlix, Paypal, Facebook, Instagram, Airbnb, Dropbox, ça vous parle ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      